import {store} from "../main";
import mapUtility from "./mapUtility";
import toast from "./toast";

const nascarData = {
    initialized: false,
    realtimeClient: null,
    topFive: [],
    isRunningTestData: false,

    //Call init on user input to start all sounds on mute
    async init() {

        const Ably = await import('ably');

        // Get 'tokens' for accessing ably and season standings
        const response = await fetch(`https://fqzqmblan3gwjlvvf3z3xfjoyi0agxxn.lambda-url.us-west-1.on.aws/?requestKey=true`, {
            method: 'GET'
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const tokens = await response.json();
        console.log('TOKENS RECEIVED');

        // Get ALL driver data (their images and all that)
        try {
            const response = await fetch(`https://cf.nascar.com/cacher/drivers.json`, {
                method: 'GET',
                headers: {}
            });

            const drivers = await response.json();

            console.log("drivers")
            console.log(drivers)

            // Remap from array to dictionary mapping driver nascar IDs to data
            let driverLookup = {}
            for(let i = 0; i < drivers.response.length; i++){
                driverLookup[drivers.response[i].Nascar_Driver_ID] = drivers.response[i];
            }

            console.log("driverLookup", driverLookup)
            //console.log(driverLookup)

            store.commit("allDrivers", driverLookup);
        } catch (error) {
            console.error("Failed to fetch drivers:", error);
        }

        // Pull static vehicle lookup
        // Used for season standings
        try {
            const response = await fetch(`https://cf.nascar.com/cacher/2026/1/live-driver-points.json`, {
                method: 'GET',
                headers: {}
            });
            
            const staticResultsLookup = await response.json();
            store.commit("staticResultsLookup", staticResultsLookup);

            console.log("Static vehicle lookup", staticResultsLookup)
            //console.log(staticResultsLookup)
        } catch (error) {
            console.error("Failed to fetch static vehicle lookup:", error);
        }

        // Pull season standings
        // CUrrently not really used for season standings because the previous call is correct?
        try {

            // TODO hand season and series to Lambda lookup
            const season = new Date().getFullYear();
            const series = '1'; // TODO: handle multiple series??
            const response = await fetch(`https://fqzqmblan3gwjlvvf3z3xfjoyi0agxxn.lambda-url.us-west-1.on.aws`, {
                method: 'GET',
                headers: {}
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const driverPoints = await response.json();
            //console.log(driverPoints)


            console.log(`Received driver points: ${driverPoints}`);
            store.commit("driverPoints", driverPoints.standings);

        } catch (error) {
            console.error("Failed to fetch season standings:", error);
        }


        // Initialize Ably
        this.realtimeClient = new Ably.Realtime({
            key: tokens.ably, // .ably vs .prod
            clientId: 'nascar-mrbd'
        });

        await this.realtimeClient.connection.once('connected');
        console.log(`Connected to Ably.`);

        const channel = this.realtimeClient.channels.get('VehicleEntryList');
        console.log('Subscribing to VehicleEntryList...');
        await channel.subscribe((message) => {
            console.log("vehicleEntryList updated")

            try {

                let vehicleEntryList = message.data;
                if(typeof message.data === "string"){
                    vehicleEntryList = JSON.parse(message.data);
                }

                console.log(vehicleEntryList)

                if (store.getters.raceMetadata == null) {
                    store.commit("raceMetadata", vehicleEntryList.run);
                }
                if (vehicleEntryList.entries != null && store.getters.entries.length == 0) {
                    store.commit("entries", vehicleEntryList.entries);
                }

                // sort results by position
                // TODO: decompose results into just what we need?
                // TODO: do we need to account for caution laps?
                const currentLap = vehicleEntryList.run.ttl_laps - vehicleEntryList.run.laps_rem
                if (vehicleEntryList.riRun.Stage4Laps != null && vehicleEntryList.riRun.Stage3End != null && currentLap >= vehicleEntryList.riRun.Stage3End) {
                    store.commit("currentStage", 4);
                }
                else if (vehicleEntryList.riRun.Stage3Laps != null && vehicleEntryList.riRun.Stage2End != null && currentLap >= vehicleEntryList.riRun.Stage2End) {
                    store.commit("currentStage", 3);
                }
                else if (vehicleEntryList.riRun.Stage2Laps != null && vehicleEntryList.riRun.Stage1End != null && currentLap >= vehicleEntryList.riRun.Stage1End) {
                    store.commit("currentStage", 2);
                }
                else if (vehicleEntryList.riRun.Stage1Laps != null) {
                    store.commit("currentStage", 1);
                }
                // else, there are no stages in this race, so keep it null


                store.commit("lapsRemaining", vehicleEntryList.run.laps_rem);
                store.commit("results", vehicleEntryList.results.sort((a, b) => a.ps - b.ps));

                let nextFlag = vehicleEntryList.flgs.at(-1);
                if(nextFlag != null){
                    if (store.getters.currentFlag == null || store.getters.currentFlag.flg != nextFlag.flg) {
                        store.commit("currentFlag", nextFlag);
                        toast.addToast({
                            type: "flag-change",
                            data: nextFlag
                        })
                    }
                }
                


                //Generate random colors
                if(store.getters.results.length > store.getters.allDriverColors.length){
                    let allDriverColors = [];
                    for(let i = 0; i < store.getters.results.length; i++){
                        allDriverColors.push(mapUtility.generateRandomHex());
                    }
                    store.commit("allDriverColors", allDriverColors);
                }


                let nextLeader = vehicleEntryList.leaders.at(-1);
                console.log("nextLeader")
                console.log(nextLeader)
                if(nextLeader != null){
                    if(store.getters.currentLeader == null || (nextLeader != null && store.getters.currentLeader.no != nextLeader.no)){

                        //search entries for actual driver data
                        if (vehicleEntryList.entries != null){
                            for (let i = 0; i < vehicleEntryList.entries.length; i++) {
                                if (vehicleEntryList.entries[i].veh.no == nextLeader.no) {
                                    store.commit("currentLeader", nextLeader);
                                    toast.addToast({
                                        type: "race-leader",
                                        data: vehicleEntryList.entries[i]
                                    })
                                    break;
                                }
                            }
                        }
                    }
                }
                


                if(this.topFive.length == 0){
                    // If first time filling top 5
                    for(let i = 0; i < 5; i++){
                        let {vehicleNo, driverID} = this.getVehicleNoFromData(store.getters.results[i]);
                        const index = i;

                        this.topFive.push({
                            vehicleNo: vehicleNo,
                            channel: this.realtimeClient.channels.get(`vehicle${vehicleNo}`),
                            boundFunction: this.telemetryListener.bind(this, index)
                        })

                        
                        this.topFive[i].channel.subscribe(this.topFive[i].boundFunction);
                    }
                } else {
                    // If updating top 5
                    for(let i = 0; i < 5; i++){
                        let {vehicleNo, driverID} = this.getVehicleNoFromData(store.getters.results[i]);
                        const index = i;

                        if(this.topFive[i].vehicleNo != vehicleNo){
                            this.topFive[i].channel.unsubscribe();

                            this.topFive.push({
                                vehicleNo: vehicleNo,
                                channel: this.realtimeClient.channels.get(`vehicle${vehicleNo}`),
                                boundFunction: this.telemetryListener.bind(this, index)
                            })

                            
                            this.topFive[i].channel.subscribe(this.topFive[i].boundFunction);
                        }
                    }
                }
            } catch (e) {
                console.error('[VehicleEntryList] Failed to parse message:', e);
            }
        });
    },
    telemetryListener(index, message){
        try {
            let telemetry = message.data;
            if(typeof message.data == 'string'){
                telemetry = JSON.parse(message.data);
            }
            //console.log(`Received telemetry data from vehicle ${index}`);
            //console.log(telemetry)

            let mapPositions = mapUtility.gpsToPixel(telemetry.location[0], telemetry.location[1], 
                mapUtility.mapCornersCurrent, mapUtility.mapCornersCurrent.width, mapUtility.mapCornersCurrent.height);
            
            if(mapPositions == null){
                telemetry.remappedLocations = {
                    x: 0,
                    y: 0
                }
            } else {
                telemetry.remappedLocations = {
                    x: mapPositions.x,
                    y: mapPositions.y
                }
            }
           
            //telemetry.color = mapUtility.generateRandomHex()

            store.commit("topFiveTelemetry", {
                telemetry: telemetry,
                index: index,
            })
            return telemetry;
        } catch (e) {
            console.error(`[vehicle position ${index}] Failed to parse message:`, e);
            return null;
        }
    },
    telemetryListenerSingleDriver(storeVariable, message){
        try {
            let telemetry = message.data;
            if(typeof message.data == 'string'){
                telemetry = JSON.parse(message.data);
            }

            //console.log("single telemetry received: " + storeVariable)
            //console.log(telemetry)

            let mapPositions = mapUtility.gpsToPixel(telemetry.location[0], telemetry.location[1], 
                mapUtility.mapCornersCurrent, mapUtility.mapCornersCurrent.width, mapUtility.mapCornersCurrent.height);
            if (mapPositions == null) {
                telemetry.remappedLocations = {
                    x: 0,
                    y: 0
                }
            } else {
                telemetry.remappedLocations = {
                    x: mapPositions.x,
                    y: mapPositions.y
                }
            }

            store.commit(storeVariable, telemetry)
        } catch (e) {
            console.error(`[vehicle position ${index}] Failed to parse message:`, e);
        }
    },
    async runTopTestData(){
        const response = await fetch('./assets/data/testData.json');
        const data = await response.json();
        //console.log(data);
        let events = data.events;
        this.isRunningTestData = true;
        let index = 0;
        while(this.isRunningTestData){
            if(index >= events.length){
                index = 0;
            }

            const message = {
                data: events[index]
            }

            this.telemetryListenerSingleDriver("topDriverTelemetry", message);
            index++;

            await new Promise(resolve => setTimeout(resolve, 1000));
        }
       
    },
    getVehicleNoFromData(resultData){
        console.log(resultData)
        let vehicleNo = 0;
        let driverID = 0;
        if(resultData?.riData != null){
            vehicleNo = resultData.no;
            driverID = resultData.riData.NASCARDriverID;
        } else if (resultData?.drv != null){
            vehicleNo = resultData.veh.no;
            driverID = resultData.drv.id;
        }
        return {driverID, vehicleNo}
    }
};

export default nascarData;
